export const IndustriesList = [
  "AdTech",
  "Advertising, Marketing & PR",
  "Agriculture",
  "AgriTech",
  "AI",
  "Animal Welfare",
  "Arts",
  "Audio Technology",
  "Augmented Reality",
  "Automobile",
  "BAME founders",
  "Beauty & Personal Care",
  "BeautyTech",
  "Biotechnology",
  "Blockchain/Web3",
  "Branding",
  "Building and Maintenance",
  "Business Transformation",
  "Cannabis/CBD",
  "Charity/Non-Profit",
  "Chemicals",
  "Chemical Technology",
  "Childcare",
  "CleanTech",
  "Cloud Based",
  "Community Improvement",
  "Computer Vision",
  "ConstructTech",
  "Consumer Goods",
  "Consumer Tech",
  "Corperate",
  "Cosmetics",
  "Crypto",
  "Cybersecurity",
  "Data",
  "DeepTech",
  "DevOps",
  "Design and Creative",
  "Digital Media",
  "Distribution & Logistics",
  "DTC",
  "Drone Tech",
  "E-Commerce",
  "EdTech",
  "Education",
  "Electic Vehicles",
  "Energy",
  "Energy & Utilities",
  "Engineering",
  "Entertainment",
  "Environment",
  "ESG (Environmental, Social, Governance)",
  "eSports",
  "Events",
  "Experiences",
  "Fashion",
  "Female Founders",
  "FemTech",
  "Financial Services",
  "Fintech",
  "Fitness",
  "FoodTech",
  "Food & Beverage",
  "Future of Work",
  "Gambling & Gaming",
  "Goverment",
  "Geentech",
  "Health Tech",
  "Healthcare & Pharmaceuticals",
  "Hospitality",
  "HR Tech",
  "Human Resources",
  "Impact",
  "Inovation",
  "Insurance",
  "InsureTech",
  "IOT (Internet Of Things)",
  "Learning & Development",
  "Legal",
  "Legal Tech",
  "Leisure",
  "Logistics",
  "Luxury Goods",
  "Machine Learning",
  "Manufacturing",
  "Market Place",
  "Media",
  "Medical",
  "MedTech",
  "Mental Health",
  "Military",
  "Mobile Application",
  "Music",
  "Music Tech",
  "Natural Resources",
  "Network Effects",
  "Oil and Gas",
  "Online Dating",
  "Operations",
  "Performance Marketing",
  "Printing/ Publishing/ Media",
  "Property and Construction",
  "PropTech",
  "Real Estate",
  "Recruitment",
  "RecruitTech",
  "RegTech",
  "Retail",
  "Saas",
  "Sales",
  "Scientific/Research",
  "Security",
  "SexTech",
  "Smart City",
  "Social Care",
  "Social Networks",
  "Socially Consious",
  "Software",
  "Sports",
  "Stratagy",
  "Supply Chain",
  "Sustainability",
  "Tech for Good",
  "Technology",
  "Telecomunications",
  "Tourism",
  "Transport & Travel",
  "Travel",
  "Unknown",
  "Virtual Reality",
  "Waste Management & Recycling",
  "Wealth Management",
  "Web3",
  "Wellbeing",
  "Wellness",
  "WorkPlace",
];

export const PreferredLocationList = [
  "Global",
  "UK",
  "Europe",
  "USA",
  "Asia",
  "Africa",
  "South America",
  "North America",
  "Australia",
  "New Zealand",
  "North Africa",
  "South Africa",
  "Middle East",
];

export const CustomerGroupsList = [
  "B2B",
  "B2C",
  "B2B2C",
  "C2B",
  "C2C",
  "D2C",
  "Enterprise",
  "P2P",
];

export const InvestmentStageList = [
  "Currently Raising Pre-seed",
  "Pre-Seed",
  "Seed",
  "Series A",
  "Series B",
  "Series C",
  "Post-Series C",
];

export const ServiceProvidersList = [
  "Google Cloud",
  "AWS",
  "Azure",
  "Vercel",
  "GCP",
  "Digital Ocean",
  "Linode",
  "Other",
];

export const ProductStageList = [
  "Idea",
  "Prototype",
  "MVP",
  "Achiving Sales",
  "Scaling",
];

//Ticket Size range: 0 - 2,500,000
//Investments made (For internal use only)
//Are you deploying capital in the next 3 months? (For internal use only)
//hanks for completing your profile information. Once you log in, please use the guides in the resource centre to help you navigate

//Set your smart match settings
//Set your Key metrics and ranges
//View profiles and materials
//Connect to start messaging
//Invest and track
